export { default } from './Col3Text'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col3Text/index.js